const XbsngSubmStatusSearchKeys = {
  MBL_NO: "mblNo",
  HBL_NO: "hblNo",
  FILER_CODE: "filerCode",
  REF_NO: "refNo",
  MSG_FUNC: "msgFunc",
  STATUS: "status",
  CREATED_DATE: "createdDate",
  TRANS_ID: "transId",
  RES_HBL_NO: "resHblNo",
  RES_REF_NO: "resRefNo",
  RES_DATE: "resDate",
  RES_CODE: "resCode",
  MSG_TYPE: "msgType",
  USER_ID: "userId",
  XBS_ORG_ID: "xbsOrgId",
  ACE_OCEAN_XBSNG_SUBM_STATUS_SEARCH_TITLE: "aceOcnXbsngSubmStatusSearchTitle",
  ACE_ISF_XBSNG_SUBM_STATUS_SEARCH_TITLE: "aceIsfXbsngSubmStatusSearchTitle",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  SN: "sn",
  SENT: "sent",
  SEND_FAILED: "sendFailed",
  PROCESSING: "processing",
  VALIDATION_ERROR: "validationError",
  CANCELLED: "cancelled",
  ERROR: "error"
}

export default XbsngSubmStatusSearchKeys